/**
 * Temporary brand gate for the homepage category chips.
 *
 * The product feed (`GET /product/feed/schema`) is shared: it advertises the same
 * four category types to every brand, with no flavour scoping and no parameters.
 * Peter Pans doesn't sell accommodation or transport, so those two chips are
 * hidden here until the feed itself is made brand-aware.
 *
 * Remove this once the backend scopes the feed per flavour — deciding which
 * categories a brand sells is not the frontend's job, and a list hardcoded here
 * will silently rot as the feed changes.
 */
const HIDDEN_CHIP_TYPES_BY_FLAVOR: Record<string, string[]> = {
    peterpans: ["accommodations", "transports"],
};

/**
 * The chip types to show for a flavour. Matching is case- and whitespace-
 * insensitive because the values come from the backend feed verbatim; an
 * unrecognised flavour hides nothing.
 */
export const visibleChipTypes = (
    chipTypes: string[],
    flavor: string | undefined = process.env.REACT_APP_FLAVOR,
): string[] => {
    const hidden = HIDDEN_CHIP_TYPES_BY_FLAVOR[(flavor ?? "").trim().toLowerCase()] ?? [];
    if (hidden.length === 0) return chipTypes;
    return chipTypes.filter((type) => !hidden.includes((type ?? "").trim().toLowerCase()));
};
